import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALFINANCE_LOAD_BY_TRIAL_ID,
    ACTION_TRIALFINANCE_LOAD_BY_ID,

    ACTION_TRIALFINANCE_SAVE,

    ACTION_TRIALFINANCE_CREATE,

    ACTION_TRIALFINANCE_VALIDATE,

    ITrialFinanceLoadByTrialIdAction,
    ITrialFinanceLoadByIdAction,
    ITrialFinanceLoadFailureAction,
    ITrialFinanceLoadSuccessAction,

    ITrialFinanceSaveAction,
    ITrialFinanceSaveSuccessAction,
    ITrialFinanceSaveFailureAction,

    ITrialFinanceCreateAction,
    ITrialFinanceCreateSuccessAction,
    ITrialFinanceCreateFailureAction,

    ITrialFinanceValidateAction,
    ITrialFinanceValidateSuccessAction,
    ITrialFinanceValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialFinance";
import { trialFinanceApi } from "../services/trialFinance";

export const
    getTrialFinanceByTrialIdEpic = (action$): Observable<ITrialFinanceLoadSuccessAction | ITrialFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALFINANCE_LOAD_BY_TRIAL_ID)
            .mergeMap((action: ITrialFinanceLoadByTrialIdAction) => {
                return trialFinanceApi
                    .getTrialFinanceByTrialId(action.trialId)
                    .map(response =>
                        LoadSuccess(response.trialFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialFinanceByIdEpic = (action$): Observable<ITrialFinanceLoadSuccessAction | ITrialFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALFINANCE_LOAD_BY_ID)
            .mergeMap((action: ITrialFinanceLoadByIdAction) => {
                return trialFinanceApi
                    .getTrialFinanceById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialFinanceEpic = (action$): Observable<ITrialFinanceSaveSuccessAction | ITrialFinanceSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALFINANCE_SAVE)
            .mergeMap((action: ITrialFinanceSaveAction) => {
                return trialFinanceApi
                    .setTrialFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialFinanceEpic = (action$): Observable<ITrialFinanceCreateSuccessAction | ITrialFinanceCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALFINANCE_CREATE)
            .mergeMap((action: ITrialFinanceCreateAction) => {
                return trialFinanceApi
                    .createTrialFinance(action.trialId)
                    .map(response =>
                        CreateSuccess(
                            response.trialFinance,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialFinanceEpic = (action$): Observable<ITrialFinanceValidateSuccessAction | ITrialFinanceValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALFINANCE_VALIDATE)
            .mergeMap((action: ITrialFinanceValidateAction) => {
                return trialFinanceApi
                    .validateTrialFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }